import { Heading } from '@frontendmentorio/design-system-v2';

import FAQs from 'features/shared/FAQs';

export default function ProFAQs() {
  return (
    <div className="px-5 py-6 tablet:py-8">
      <div className="container-sm flex flex-col gap-7">
        <Heading className="text-center" level="3" tagName="h2">
          Frequently Asked Questions
        </Heading>

        <FAQs>
          <FAQs.FAQ question="Can I get my employer to pay for my subscription?" />
          <FAQs.FAQ question="Why are there credits limits on the monthly subscription?" />
          <FAQs.FAQ question="Do you offer discounts?" />
          <FAQs.FAQ question="Do you offer refunds?" />
          <FAQs.FAQ question="Can I cancel my subscription any time?" />
          <FAQs.FAQ question="Does the subscription auto-renew?" />
          <FAQs.FAQ question="What happens when my subscription expires?" />
        </FAQs>
      </div>
    </div>
  );
}
